import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import router from './routes/router';

Vue.use(DashboardPlugin);
new Vue({
    el: '#app',
    data: {
        user: null,
        app_name: process.env.APP_NAME,
        locale: process.env.MIX_LOCALE,
        locales: process.env.MIX_LOCALES.split(','),
        base_path: process.env.MIX_BASE_PATH,
        back: {name: 'dashboard'},
        default_back: {name: 'dashboard'},
    },
    render: h => h(App),
    router
});